import { ConnectUserType } from './appTypes'
import { constants } from './constants'
import { getStorage } from './getStorage'

export const getConnectUser = () => {
    return (getStorage(constants.CONNECT_USER) || {
        country: '',
        exp: 0,
        iat: 0,
        language: '',
        role: '',
        sf_id: '',
        token: '',
        user_id: 0,
        username: '',
        veVillages: [],
        zoneName: '',
        zoneSFID: '',
        zoneCode: '',
        staff_code: '',
        phone_number: '',
        phone_flotte: ''
    }) as ConnectUserType
}
